import Vue from 'vue';
import store from '@/store';

export const saveState = function() {
    Vue.prototype.$cookies.set('token', store.state.token, '1d');
    localStorage.setItem('user_info', JSON.stringify({
      email: store.state.user.email,
      phone: store.state.user.phone,
      openid: store.state.user.openid,
      full_name: store.state.user.full_name,
      user_type: store.state.user.user_type,
      company: store.state.user.company,
      userId: store.state.user.userId,
      menuList: store.state.user.menuList,
      btnList: store.state.user.btnList,
      role_list: store.state.user.role_list,
    }));
}

// export const retoreState = function() {
//     return;
//     console.log(Vue);
//     if (Vue.prototype.$cookies.isKey('token')) {
//         Vue.prototype.$store.commit('updateState', {
//             token: Vue.prototype.$cookies.get('token')
//         });
//         Vue.prototype.$store.commit('user/updateState', JSON.parse(localStorage.getItem('user_info')));
//         Vue.prototype.$store.commit('user/updateState', JSON.parse(localStorage.getItem('user_permission')));
//     }
// }

export const clearState = function() {
    Vue.prototype.$cookies.remove('token');
    localStorage.removeItem('user_info');
    store.commit('clearSession');
}

export const hasState = function() {
    return Vue.prototype.$cookies.isKey('token');
}